<template>
<v-layout column align-center>
  <v-card
    color="blue-gray"
    dark
    width="50%"
    >
    <v-card-title>Login</v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        >
        <v-text-field
          v-model="username"
          label="Username"
          :error="tfError"
          required
          ></v-text-field>

        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          :error="tfError"
          required
          ></v-text-field>

        <v-btn
          color="success"
          class="mr-4"
          @click="login"
          >
          Login
        </v-btn>

      </v-form>
    </v-card-text>
  </v-card>


</v-layout>
</template>


<script>
import { config } from '../config';

export default {
    name: 'Login',
    data: () => ({
        username: '',
        password: '',
        tfError: false,
    }),

    computed: {
    },

    methods: {
        login() {
            const creds = {
                username: this.username,
                password: this.password,
            };

            const url = `${config.baseUrl}login`;

            this.$http.post(url, creds).then((res) => {
                if (res.status === 200) {
                    this.$store.commit('UPDATE_CREDS', creds);
                    this.$store.commit('TOGGLE_AUTH');
                }
            }).catch((err) => {
                if (err.response.status === 403 && err.response.data === 'access denied') {
                    this.tfError = true;
                    this.$notify({
                        group: 'ui',
                        title: 'Error',
                        text: 'Password or username is invalid !',
                        type: 'error',
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
